import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap"

function MobilePeopleSearch({ peopleData, onClick }) {

    return (
        <>
            <div onClick={onClick}>
                <Container fluid className=" border-b border-solid border-gray-300 py-1">
                    <a href={`http://wisemonkeys.info/${peopleData.username}`} className=" no-underline text-black">
                        <Row className="items-center">
                            <Col md={2} xs={3} className="pr-0 pl-0 flex items-center justify-center">
                                <div className="w-12 h-12 overflow-hidden rounded-full bg-gray-200">
                                    <img src={peopleData.profile_photo} alt="people" className="w-full h-full object-cover" />
                                </div>
                            </Col>
                            <Col md={10} xs={9}>
                                <div>
                                    <span className="manpro">{peopleData.full_name}</span>
                                </div>
                            </Col>
                        </Row>
                    </a>
                </Container>
            </div>
        </>
    );
}

export default MobilePeopleSearch;
